import React, { useEffect } from 'react';
import ProduitsHeader from './ProduitsHeader';
import { Row } from 'react-bootstrap';
import ProduitsTable from './produitsTable';
import { useState } from 'react';
import { fetchClassmentProduit } from 'data/produits';
const Produits = () => {
  const [actif, setActif] = useState(true);
  const [secteur, setSecteur] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [famille, setFamille] = useState([]);

  useEffect(() => {
    const fetchClassement = async () => {
      const data = await fetchClassmentProduit();
      console.log(data);
      setSecteur(
        data.secteurs.map(({ secteur }) => ({
          value: secteur,
          label: secteur,
        }))
      );
      setCategorie(
        data.categories.map(({ categorie }) => ({
          value: categorie,
          label: categorie,
        }))
      );
      setFamille(
        data.familles.map(({ famille }) => ({
          value: famille,
          label: famille,
        }))
      );
    };

    fetchClassement();
  }, []);

  return (
    <>
      <Row>
        <ProduitsHeader />
      </Row>
      <Row>
        <ProduitsTable actif={actif} secteur={secteur} categorie={categorie} famille={famille} />
      </Row>
    </>
  );
};

export default Produits;
